import styled from "styled-components";
import { colours } from "../../../../../styles/colours.constants";
import { satoshi500, satoshi900 } from "../../../../../styles/font.constants";

export const FeedHeader = styled.div<{ $minimised?: boolean }>`
	background: ${colours.blueGrey};
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: ${({ $minimised }) =>
		$minimised ? "0.75rem 1.5rem" : "2rem 1.5rem"};
	transition: padding 0.5s ease;
`;

export const DateText = styled.div`
	${satoshi500}
	color: ${colours.greyMedium}B2;
	font-size: 0.875rem;
`;

export const Venue = styled.div`
	${satoshi500}
	color: ${colours.white};
	font-size: 0.875rem;
	margin-top: 0.5rem;
`;

export const TeamsScore = styled.div<{ $minimised?: boolean }>`
	display: flex;
	align-items: center;
	margin-top: ${({ $minimised }) => ($minimised ? "0" : "2rem")};
	transition: margin-top 0.5s ease;
`;

export const Team = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	justify-content: center;
	align-items: center;
	width: 9rem;
`;

export const ScoreContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 5rem;
`;

export const TeamName = styled.div`
	${satoshi900}
	color: ${colours.white};
	font-size: 0.9375rem;
`;

export const Score = styled.div`
	${satoshi900}
	color: ${colours.white};
	font-size: 1.75rem;
`;

export const Minutes = styled.div`
	${satoshi500}
	color: ${colours.white};
	font-size: 1.125rem;
`;
